import { Component, Inject, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { User } from '../../models/user';
import { ErrorService } from '../../services/error.service';
import { OrderService } from '../../services/order.service';
import { SnackbarService } from '../../services/snackbar.service';
import { SpinnerService } from '../../services/spinner.service';
import { SubscriptionService } from '../../services/subscription.service';
import { UserService } from '../../services/user.service';
import { ValidatorService } from '../../services/validator.service';

@Component({
	selector: 'app-email-shipping-label-modal',
	templateUrl: './email-shipping-label-modal.html',
	styleUrls: ['./email-shipping-label-modal.component.scss']
})
export class EmailShippingLabelModalComponent implements OnInit, OnDestroy {
	public form: UntypedFormGroup;
	public selectedLabelIsDefault: boolean;
	public shippingLabels: any[];
	public subscriptions: any[] = [];
	public user: User = new User();

	constructor(private _orderService: OrderService,
				private _userService: UserService,
				private _vcRef: ViewContainerRef,
				private _errorService: ErrorService,
				public dialogRef: MatDialogRef<EmailShippingLabelModalComponent>,
				@Inject(MAT_DIALOG_DATA) public data: any,
				private _formBuilder: UntypedFormBuilder,
				private _validatorService: ValidatorService,
				private _spinnerService: SpinnerService,
				private _snackbarService: SnackbarService,
				private _subscriptionService: SubscriptionService) {
	}

	close(response?) {
		this.dialogRef.close(response);
	}

	getAvailableShippingLabels() {
		this._orderService.getAvailableShippingLabels().subscribe(response => {
			if (response && response.length > 0) {
				this.shippingLabels = response;
				if (response?.length > 0) {
					this.form.controls.selectedShippingLabel.setValue(response[0].procedureId, {onlySelf: true});
					this.form.controls.subject.setValue(`${this.data.id} Shipping Label`, {onlySelf: true});
					this.form.controls.message.setValue(`${this.data.name} has sent you a shipping label for Order id ${this.data.id}. If you have any questions, please contact your carrier.`, {onlySelf: true});
					this.form.markAsPristine();
				}
			}
		}, error => {
			this.close(error);
			this._errorService.error(error, 'getAvailableShippingLabels Failed', 'modal');
		});
	}

	ngOnDestroy() {
		this._subscriptionService.unSubscribe(this.subscriptions);
	}

	ngOnInit() {
		this.form = this._formBuilder.group({
			email: ['', [Validators.email]],
			emails: [[], [this._validatorService.minArrayLength(1)]],
			selectedShippingLabel: [null, []],
			includePieces: [null, []],
			subject: [null, [Validators.required]],
			message: [null, [Validators.required]]
		});
		this.form.get('selectedShippingLabel').valueChanges.subscribe((value) => {
			this.selectedLabelIsDefault = !!this.shippingLabels.find((label) => label.procedureId === value && label.isDefault);
		})
		this.subscriptions.push(this._userService.user$.subscribe((data) => {
			this.user = data;
			if (this.user && this.user.token && this.user.type === 'inet') {
				this.getAvailableShippingLabels();
			}
		}));
		this.subscriptions.push(this.form.get('emails').valueChanges.subscribe((value) => {
			if (value?.length === 10) {
				this.form.get('email').disable();
			} else if (this.form.get('email').disabled && value?.length < 10) {
				this.form.get('email').enable();
			}
		}));
	}

	submit(form) {
		if (form.valid) {
			this._spinnerService.startSpinner();
			this._orderService.emailShippingLabel(this.data.id, form.value.selectedShippingLabel, {
				subject: form.value.subject,
				body: form.value.message,
				emails: form.value.emails
			}, form.value.includePieces).subscribe(() => {
				this._spinnerService.stopSpinner();
				this.close(true);
			}, error => {
				this._spinnerService.stopSpinner();
				this._errorService.error(error, 'emailShippingLabel Failed', 'modal');
			});
		} else {
			if (this.form.get('emails').errors) {
				this.form.get('email').setErrors({minLength: true});
				this.form.get('email').markAsTouched();
			}
			this._snackbarService.openSnackBar('Please fill out all required fields.', 'Close', 3000);
		}
	}
}
